////////////////////////////////////////////////////////////
//     							                                      //
//  Program: recent inspection                             //
//  Application: Dashboard                                //
//  Option: to view Dashboard                             //
//  Developer: Kiran singh  						                  //
//  Date: 2024-03-14                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { PureComponent } from "react";
import Moment from "moment";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export class TodayEvents extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      userData: global.userData ? global.userData : {},
      eventData: this.props.eventData ? this.props.eventData : [],
    };
  }
  render() {
    const { isLoading = false, eventData = [] } = this.props;

    return (
      <div className="card card-dashboard-sixteen">
        <div className="card-header">
          <h6 className="card-title tx-14 mg-b-0">
            {"Today's Event"}
            {global.userPermissions.checkPermission("calendar-list") &&
              eventData.length > 0 && (
                <Link to="/daily-event" className="btn_view">
                  View More
                </Link>
              )}
          </h6>
        </div>
        <div className="card-body custom-table-box add-scroll-event">
          <div
            className={`table-responsive ${
              eventData.length === 0 ? "no-record-data" : ""
            }`}
          >
            <table className="table mg-b-0">
              <tbody>
                {isLoading ? (
                  Array(2)
                    .fill()
                    .map((_, index) => (
                      <tr key={`skeleton_${index}`}>
                        <td>
                          <h6 className="mg-b-0">
                            <Skeleton width={150} />
                          </h6>
                          <small className="tx-11">
                            <Skeleton width={100} />
                          </small>
                        </td>
                        <td>
                          <h6 className="mg-b-0">
                            <Skeleton width={100} />
                          </h6>
                          <small className="tx-11">
                            <Skeleton width={80} />
                          </small>
                        </td>
                      </tr>
                    ))
                ) : eventData.length > 0 ? (
                  eventData.map((el, index) => (
                    <tr key={"ins" + index}>
                      <td>
                        <Link
                          to={`/daily-event`}
                          className="link-style"
                        >
                          <h6 className="mg-b-0 ">
                            {el.title ? el.title : ""}
                          </h6>
                          <small className="tx-11">
                            {el.property_name ? 
                              el.property_name.split(' ').slice(0, 5).join(' ') + 
                              (el.property_name.split(' ').length > 5 ? '...' : '')
                              : ""
                            }
                          </small>
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`/daily-event`}
                          className="link-style"
                        >
                          <h6 className="mg-b-0 ">
                            {(() => {
                              const isValidTime = (time) => time && typeof time === 'string';
                              
                              const formatTimeString = (timeStr) => {
                                if (!isValidTime(timeStr)) return null;
                                // Combine with today's date to create a valid datetime
                                const today = Moment().format('YYYY-MM-DD');
                                const fullDateTime = `${today} ${timeStr}`;
                                return Moment(fullDateTime, 'YYYY-MM-DD HH:mm:ss').format('hh:mm A');
                              };
                              
                              const startTime = formatTimeString(el.start_time);
                              const endTime = formatTimeString(el.end_time);
                              
                              if (startTime && endTime) {
                                return `Today (${startTime} - ${endTime})`;
                              } else if (startTime) {
                                return `Today (${startTime})`;
                              } else if (endTime) {
                                return `Today (${endTime})`;
                              } else {
                                return "Today";
                              }
                            })()}
                          </h6>
                          <small className="tx-11">
                            {el.inspector?.full_name || ""}
                          </small>
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <div className="no-recrod-found" key="1">
                    No record found
                  </div>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default TodayEvents;
